import { Send } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header, EmptyState, Outcome } from "./AdminPagePrimitives";
import { formatDate } from "./admin-presentation";

import { useAdminNotificationsWorkspace } from "./useAdminNotificationsWorkspace";

export function NotificationsPage({notify}: {notify: Notify}) {
  const { rows, testSubmitting, sendTestEmail } = useAdminNotificationsWorkspace({notify});
  return (
    <>
      <Header
        eyebrow="Kurumsal e-posta"
        title="E-posta Bildirimleri"
        description="Microsoft Graph kuyruğundaki gönderim ve yeniden deneme kayıtlarını izleyin. Test yalnız yapılandırılmış hesaba gider; kullanıcı, rol ve davet kaydı oluşturmaz."
        action={
          <button className="primary-button" disabled={testSubmitting} onClick={() => void sendTestEmail()}>
            <Send size={15} /> {testSubmitting ? "Test e-postası gönderiliyor…" : "Kendime test e-postası gönder"}
          </button>
        }
      />
      <section className="module-card">
        {rows.length ? (
          <div className="data-table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Olay</th>
                  <th>Alıcı</th>
                  <th>Durum</th>
                  <th>Deneme</th>
                  <th>Oluşturulma</th>
                  <th>Son hata</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <strong>{row.event_type}</strong>
                      <small>{row.template_key}</small>
                    </td>
                    <td>{row.recipient}</td>
                    <td>
                      <Outcome value={row.status} />
                    </td>
                    <td>
                      {row.attempt_count}/{row.max_attempts}
                    </td>
                    <td>{formatDate(row.created_at)}</td>
                    <td>{row.last_error ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <EmptyState
            title="Bildirim kaydı bulunmuyor"
            description="Kurumsal bildirim oluştuğunda gönderim durumu burada izlenecek."
          />
        )}
      </section>
    </>
  );
}
